// extracted by mini-css-extract-plugin
export var actions = "CookieConsent-module--actions--3IUVW";